import { apiFetch } from "./fetchApi"

export const fetchSessionLogsApi = (BeURL, setSessionLogs, currentPage, rowsPerPage, setTotlaSessionLogs, setTotalPage) => {
    console.log("Fetch succes")
    apiFetch(`${BeURL}/fetch-session-logs`, {
        method : 'POST',
        body: JSON.stringify({ pages: currentPage, sessionLogsPerPage: rowsPerPage })
    })
        .then(res => res.json())
        .then(data => {
            if (data.success === true) {
                console.log("Session logs are", data)
                setSessionLogs(data.sessionLogs)
                setTotlaSessionLogs(data.totalLogs)
                setTotalPage(data.totalPages)
            }
            else {
                alert(data.message)
            }
        })
        .catch(err => {
            console.error('Error fetching session logs:', err);
        })
}